import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import fondo from "../assets/fondo1.jpg";
import SectionHeader from "./SeccionHeader";

const API = "https://aldanaselena.com/viajes.php";

const Viajes = () => {
  const [viajes, setViajes] = useState([]);

  const { t, i18n } = useTranslation();

  // ================= FETCH =================
  useEffect(() => {
    axios
      .get(API)
      .then((res) => setViajes(res.data))
      .catch((err) => console.error(err));
  }, []);

  // ================= ANIMACIONES =================
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const stagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  // ================= AGRUPAR POR MES =================
  const grouped = viajes.reduce((acc, viaje) => {
    if (!acc[viaje.mes]) acc[viaje.mes] = [];
    acc[viaje.mes].push(viaje);
    return acc;
  }, {});

  // ================= FORMATEAR FECHA =================
  const formatFecha = (inicio, fin) => {
    const d1 = new Date(inicio + "T12:00:00");
    const d2 = new Date(fin + "T12:00:00");

    const diaInicio = d1.getDate();
    const diaFin = d2.getDate();

    if (diaInicio === diaFin) return `${diaInicio}`;

    return `${diaInicio}–${diaFin}`;
  };

  // ================= TRADUCIR MES =================
  const translateMonth = (mes) => {
    const months = {
      Enero: t("travels.months.january"),
      Febrero: t("travels.months.february"),
      Marzo: t("travels.months.march"),
      Abril: t("travels.months.april"),
      Mayo: t("travels.months.may"),
      Junio: t("travels.months.june"),
      Julio: t("travels.months.july"),
      Agosto: t("travels.months.august"),
      Septiembre: t("travels.months.september"),
      Octubre: t("travels.months.october"),
      Noviembre: t("travels.months.november"),
      Diciembre: t("travels.months.december"),
    };

    return months[mes] || mes;
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden font-montserrat">

      {/* BACKGROUND */}
      <img
        src={fondo}
        alt="fondo"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-[#0E0B09]/80 backdrop-blur-sm" />

      {/* CONTENIDO */}
      <div className="relative z-10 w-full max-w-5xl px-6 md:px-12 py-28 mx-auto">

        <SectionHeader
          title={t("travels.title")}
          subtitle={t("travels.subtitle")}
        />

        {/* LISTADO */}
        <motion.div
          className="space-y-14"
          variants={stagger}
          initial="hidden"
          animate="show"
        >

          {Object.entries(grouped).map(([mes, lista]) => (
            <motion.div
              key={mes}
              variants={fadeUp}
              className="
                grid grid-cols-1 md:grid-cols-3
                gap-6
                items-start
              "
            >

              {/* MES */}
              <div
                className="
                  text-[#B8977F]
                  tracking-[0.4em]
                  text-xs
                  uppercase
                "
              >
                {translateMonth(mes)}
              </div>

              {/* LISTA */}
              <div className="md:col-span-2 space-y-4">

                {lista.map((v) => (
                  <motion.div
                    key={v.id}
                    variants={fadeUp}
                    className="
                      flex justify-between items-center
                      border-b border-[#3C2B22]/60
                      pb-4
                      gap-4
                    "
                  >
                    {/* CIUDAD */}
                    <div className="flex flex-col">
                      <span className="text-[#EDE0D0] text-sm md:text-base font-light">
                        {v.ciudad}, {v.pais}
                      </span>

                      <span className="text-[#7A5E50] text-[10px] uppercase tracking-[0.25em] mt-1">
                        {t("travels.available")}
                      </span>
                    </div>

                    {/* FECHA */}
                    <span className="text-[#B8977F] text-sm md:text-base tracking-wide">
                      {formatFecha(v.fecha_inicio, v.fecha_fin)}
                    </span>
                  </motion.div>
                ))}

              </div>
            </motion.div>
          ))}

          {/* EMPTY */}
          {viajes.length === 0 && (
            <motion.div
              variants={fadeUp}
              className="text-center py-12"
            >
              <p className="text-[#B8977F] italic text-sm md:text-base">
                {t("travels.empty")}
              </p>
            </motion.div>
          )}

        </motion.div>
      </div>

    </div>
  );
};

export default Viajes;